import React from 'react';
import { observer } from 'mobx-react';
import { useIntl } from 'react-intl';
import { IConnectionDetailsDTO, IConnectionGroupDTO } from '../../../../../../api/connections.dao';
import { IMeetingLinkDTO } from '../../../../../../api/meeting-links.dao';
import DefaultButton from '../../../../../global/default-button/default-button';
import { MeetingLinksViewModel } from './meeting-links.viewmodel';
import { MeetingLinkItem } from './meeting-link-item';
import {
    ADD_MEETING_LINK_BUTTON_TEXT,
    CONNECTION_COLUMN_TEXT,
    MEETING_LINKS_SECTION_TEXT,
} from './meeting-links.texts';
import { MeetingLinkInheritanceIds } from './manage-meeting-link-modal/manage-meeting-link-modal.viewmodel';
import './meeting-links.scss';

export type MeetingLinksSectionProps = {
    vm: MeetingLinksViewModel;
    connections: IConnectionDetailsDTO[];
    connectionGroups: IConnectionGroupDTO[];
    inheritanceConnections?: (IConnectionDetailsDTO | IConnectionGroupDTO)[];
    inheritanceIds?: MeetingLinkInheritanceIds;
    canManage: boolean;
    isAddActive?: boolean;
    onAddClick: () => void;
    isLinkEditing?: (meetingLinkId: number) => boolean;
    onEditClick: (link: IMeetingLinkDTO) => void;
};

export const MeetingLinksSection = observer(({
    vm,
    connections,
    connectionGroups,
    inheritanceConnections = [],
    inheritanceIds,
    canManage,
    isAddActive = false,
    onAddClick,
    isLinkEditing = () => false,
    onEditClick,
}: MeetingLinksSectionProps): JSX.Element => {
    const intl = useIntl();
    const hasLinks = vm.links.length > 0;

    return (
        <div className='attendee-list meeting-links' data-testid='meeting-links-section'>
            <div className={`attendee-list__row meeting-links__header ${hasLinks ? 'attendee-list__header' : ''}`}>
                <div className='attendee-list__label meeting-links__title'>
                    {intl.formatMessage(MEETING_LINKS_SECTION_TEXT)}
                </div>
                <div className='attendee-list__label meeting-links__title meeting-links__title--secondary'>
                    {intl.formatMessage(CONNECTION_COLUMN_TEXT)}
                </div>
            </div>
            {vm.links.map(link => (
                <MeetingLinkItem
                    key={link.meetingLinkId}
                    link={link}
                    vm={vm}
                    connections={connections}
                    connectionGroups={connectionGroups}
                    inheritanceConnections={inheritanceConnections}
                    inheritanceIds={inheritanceIds}
                    canManage={canManage}
                    isEditing={isLinkEditing(link.meetingLinkId)}
                    onEdit={onEditClick}
                />
            ))}
            {canManage && (
                <DefaultButton
                    modifier='slim'
                    className='attendee-list__add-button meeting-links__add'
                    text={intl.formatMessage(ADD_MEETING_LINK_BUTTON_TEXT)}
                    isActive={isAddActive}
                    onClick={onAddClick}
                />
            )}
        </div>
    );
});
